import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import Content from '../../../layout/Content';
import { ROUTE_PATH } from '../../../../config/paths';
import RouteForm from './RouteForm';
import { postRoute } from '../../../../actions';
import { ROUTE_LENGTH_TYPE_OPTIONS } from '../../../../config/constants';

const NewRoute = ({ breadcrumbs, dispatchPostRoute }) => {
  const onSubmit = (formValues) => {
    const routeSegmentList = formValues.routeSegmentList.map(
      (segment, index) => ({
        segmentId: segment.segmentId.value,
        segmentOrder: index,
      }),
    );

    const payload = {
      ...formValues,
      isOneWay: formValues.isOneWay ? formValues.isOneWay : false,
      isMaciva: formValues.isMaciva ? formValues.isMaciva : false,
      hotZone: formValues.hotZone ? formValues.hotZone : false,
      coldZone: formValues.coldZone ? formValues.coldZone : false,
      steepRoute: formValues.steepRoute ? formValues.steepRoute : false,
      flatRoute: formValues.flatRoute ? formValues.flatRoute : false,
      lengthType: formValues.lengthType.value,
      routeSegmentList,
      isNorthChico: formValues.isNorthChico ? formValues.isNorthChico : false,
      // This is because routes that belong to North Chico must allow sales at authorized stops
      // Currently there is only one route, to facilitate the creation of new routes this logic is added
      isPostDepartSalesAllowed: formValues.isNorthChico ? formValues.isNorthChico : false,
    };

    dispatchPostRoute(payload);
  };

  const content = <RouteForm onSubmit={onSubmit} initialValues={{
    lengthType: ROUTE_LENGTH_TYPE_OPTIONS.UNKNOWN
  }} />;

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Nueva Ruta"
      subtitle="Crear nueva Ruta"
      content={content}
    />
  );
};

NewRoute.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPostRoute: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  dispatchPostRoute: postRoute,
};

const mapStateToProps = ({ RouteUnit }) => ({
  breadcrumbs: [
    ...RouteUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Rutas',
      href: ROUTE_PATH,
    },
    {
      text: 'Nuevo',
      href: '',
    },
  ],
});

export default connect(mapStateToProps, mapDispatchToProps)(NewRoute);
